// src/services/devicecommands.js
import axios from 'axios';
import { getMqttClient, sendCommand as publishMqttCommand } from './mqttClient';

const API_BASE_URL = 'https://alcobrakeadmin.com/v3';

// Helper function to wait (ADD THIS - it's missing)
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Helper function to check if device is OLED
export const isOLEDDevice = (sno, oledDevices) => {
  if (!oledDevices || !Array.isArray(oledDevices)) return false;
  const serial = String(sno ?? '').trim().toLowerCase();
  return Boolean(serial) && oledDevices.some(device => String(device.sno ?? '').trim().toLowerCase() === serial);
};

// Get the correct device ID to send command to
export const getTargetDeviceId = (client, oledDevices) => {
  const isOled = isOLEDDevice(client.sno, oledDevices);
  const deviceId = isOled ? (client.devId || client.cbid) : (client.cbid || client.devId);
  return typeof deviceId === 'string'
    ? deviceId.replace(/^(ABC|ABS)_/i, isOled ? 'ABS_' : 'ABC_')
    : deviceId;
};

const handleCommandResponse = (response, commandName) => {
  if (
    response.data &&
    response.data.includes &&
    response.data.includes('already exists')
  ) {
    const parts = response.data.split(' ');

    const action =
      parts[1] == 90
        ? 'Lock'
        : parts[1] == 91
        ? 'Unlock'
        : parts[1] == 94
        ? 'Certification'
        : 'Perform other Action to';

    return {
      success: false,
      message: `Cannot Set Command, Waiting to ${action} the Device`
    };
  }

  if (response.data === 'OPERATION DONE') {
    return {
      success: true,
      message: `${commandName} command sent successfully`
    };
  }

  return {
    success: false,
    message: 'OPERATION NOT DONE'
  };
};
// Handle command response
// const handleCommandResponse = (response, commandName) => {
//   if (response.data && response.data.includes && response.data.includes('already exists')) {
//     const parts = response.data.split(' ');
//     const action = parts[1] == 90 ? 'Lock' : parts[1] == 91 ? 'Unlock' : 'Perform other Action to';
//     return { success: false, message: `Cannot Set Command, Waiting to ${action} the Device` };
//   }
  
//   if (response.data === 'OPERATION DONE') {
//     return { success: true, message: `${commandName} command sent successfully` };
//   }
  
//   return { success: false, message: 'OPERATION NOT DONE' };
// };

// Send command to device
// const sendCommand = async (devId, command, resp = '', refby, role) => {
//   if (getMqttClient().connected) {
//     await publishMqttCommand(devId, command, resp);
//     return { data: 'OPERATION DONE' };
//   }
//   return axios.post(`${API_BASE_URL}/app/commands`, { devId, command, resp, refby, role });
// };

// const sendConfigCommand = async (devId, command, resp, refby, role) => {
//   if (getMqttClient().connected) {
//     await publishMqttCommand(devId, command, resp);
//     return { data: 'OPERATION DONE' };
//   }
//   const cmdData = { devId, command, resp, refby, role };
//   const response = await axios.post(`${API_BASE_URL}/app/commands`, cmdData);
//   try {
//     await axios.post(`${API_BASE_URL}/app/commands/ilcommand`, cmdData);
//   } catch (error) {
//     console.log('Second endpoint error (ignored):', error);
//   }
//   return response;
// };


const sendCommand = async (devId, command, resp = '', refby, role) => {
  try {
    if (getMqttClient().connected) {
      await publishMqttCommand(devId, command, resp);
      return { data: 'OPERATION DONE' };
    }
  } catch (error) {
    console.log(
      'MQTT failed or ACK not received, using HTTP:',
      error.message,
    );
  }

  return axios.post(`${API_BASE_URL}/app/commands`, {
    devId,
    command,
    resp,
    refby,
    role,
  });
};

const sendConfigCommand = async (devId, command, resp, refby, role) => {
  try {
    if (getMqttClient().connected) {
      await publishMqttCommand(devId, command, resp);
      return { data: 'OPERATION DONE' };
    }
  } catch (error) {
    console.log(
      'MQTT failed or ACK not received, using HTTP:',
      error.message,
    );
  }

  const cmdData = { devId, command, resp, refby, role };

  const response = await axios.post(
    `${API_BASE_URL}/app/commands`,
    cmdData,
  );

  try {
    await axios.post(
      `${API_BASE_URL}/app/commands/ilcommand`,
      cmdData,
    );
  } catch (error) {
    console.log('Second endpoint error (ignored):', error);
  }

  return response;
};

// Update device status to "Installed"
const updateDeviceStatus = async (client, oledDevices) => {
  const isOled = isOLEDDevice(client.sno, oledDevices);
  const formData = new FormData();
  
  if (isOled) {
    formData.append("devid", client.devId);
    formData.append("status", "Installed");
    try {
      await axios.post(`${API_BASE_URL}/us/cadevices/editdevicemode2`, formData);
      return true;
    } catch (error) {
      console.error('Failed to update device status:', error);
      return false;
    }
  } else {
    formData.append("cbid", client.cbid);
    formData.append("status", "Installed");
    try {
      await axios.post(`${API_BASE_URL}/us/cadevices/editdevicemode`, formData);
      return true;
    } catch (error) {
      console.error('Failed to update device status:', error);
      return false;
    }
  }
};

// Create installation invoice
// const createInstallationInvoice = async (client, user) => {
//   const invoiceData = {
//     office: client.officeId,
//     client: client.client || client.name,
//     date: new Date().toLocaleDateString('en-US'),
//     service: [{
//       actualamount: "75.00",
//       description: "",
//       discount: "0",
//       service: "New-Installation",
//       total: "75"
//     }],
//     regnum: client.regNum || client.regnum,
//     total: "75.00",
//     prevbalance: "75.00",
//     grandtotal: "0.00",
//     amountpaid: "0.00"
//   };
  
//   try {
//     await axios.post(`${API_BASE_URL}/us/cainvoices/createinvoice`, invoiceData);
//     return true;
//   } catch (error) {
//     console.error('Failed to create invoice:', error);
//     return false;
//   }
// };

export const deviceCommands = {
  // Reset violation
  resetViolation: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '85', '', user.dealerId, user.role);
    return handleCommandResponse(response, 'RESET VIOLATION');
  },
  
  // Take test
  takeTest: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '84', '', user.dealerId, user.role);
    return handleCommandResponse(response, 'TAKE TEST');
  },
  
  // Lock device
  lockDevice: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '90', '', user.dealerId, user.role);
    return handleCommandResponse(response, 'LOCK DEVICE');
  },

    // Wifi Change
wifiChange: async (
  client,
  user,
  oledDevices,
  ssid,
  password
) => {
  const devId = getTargetDeviceId(client, oledDevices);

  const wifiSSID = String(ssid || '').trim();
  const wifiPassword = String(password || '');

  if (!wifiSSID || !wifiPassword) {
    return {
      success: false,
      message: 'Wi-Fi SSID and password are required'
    };
  }

  const resp = `${wifiSSID},${wifiPassword}`;

  const response = await sendCommand(
    devId,
    '100',
    resp,
    user.dealerId,
    user.role
  );

  return handleCommandResponse(
    response,
    'WIFI CHANGE'
  );
},

aucConfigure: async (
  client,
  user,
  oledDevices,
  auc,
  adc
) => {
  const devId = getTargetDeviceId(client, oledDevices);

  const aucValue = Number(auc);
  const adcValue = Number(adc);

  // AUC: float allowed, range 5-250
  if (
    Number.isNaN(aucValue) ||
    aucValue < 5 ||
    aucValue > 250
  ) {
    return {
      success: false,
      message: 'AUC must be between 5 and 250'
    };
  }

  // ADC: integer only, range 0-127
  if (
    !Number.isInteger(adcValue) ||
    adcValue < 0 ||
    adcValue > 127
  ) {
    return {
      success: false,
      message: 'ADC must be an integer between 0 and 127'
    };
  }

  // Send AUC and ADC as: AUC,ADC
  const resp = `${aucValue},${adcValue}`;

  const response = await sendCommand(
    devId,
    '107',
    resp,
    user.dealerId,
    user.role
  );

  return handleCommandResponse(
    response,
    'AUC CONFIGURE'
  );
},


   // GPS Interval Change
gpsChange: async (
  client,
  user,
  oledDevices,
  gpsInterval
) => {
  const devId = getTargetDeviceId(
    client,
    oledDevices
  );

  const interval = String(
    gpsInterval || ''
  ).trim();

  if (!interval) {
    return {
      success: false,
      message: 'GPS Interval is required'
    };
  }

  if (
    Number(interval) < 1 ||
    Number(interval) > 60
  ) {
    return {
      success: false,
      message:
        'GPS Interval must be between 1 and 60 seconds'
    };
  }

  const response = await sendCommand(
    devId,
    '106',
    interval,
    user.dealerId,
    user.role
  );

  return handleCommandResponse(
    response,
    'GPS INTERVAL'
  );
},

     // Internal Info
  internalInfo: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '78', '', user.dealerId, user.role);
    return handleCommandResponse(response, 'INTERNAL INFO');
  },

certification: async (
  client,
  user,
  oledDevices,
  certificationType,
  lastValue
) => {
  const devId = getTargetDeviceId(client, oledDevices);

  const resp = `60,30,25,40,400,${certificationType},${lastValue}`;

  const response = await sendCommand(
    devId,
    '94',
    resp,
    user.dealerId,
    user.role
  );

  return handleCommandResponse(response, 'CERTIFICATION');
},
  
  // Unlock device
  unlockDevice: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '91', '', user.dealerId, user.role);
    return handleCommandResponse(response, 'UNLOCK DEVICE');
  },
  
  // Restart device
  restartDevice: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '82', '', user.dealerId, user.role);
    return handleCommandResponse(response, 'RESTART DEVICE');
  },
  
  // Memory reset with full flow (matches Vue implementation)
  memoryReset: async (client, user, oledDevices, onProgress, clearLogs = true) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const firmwareVersion = parseFloat(client.fwversion || client.firmwareVersion || '0');
    const isOled = isOLEDDevice(client.sno, oledDevices);
    
    try {
      // Step 1: Send memory reset command (87)
      if (onProgress) onProgress('Sending memory reset command...');
      const resetResponse = await sendCommand(devId, '87', '', user.dealerId, user.role);
      
      if (resetResponse.data !== 'OPERATION DONE') {
        return { success: false, message: 'Memory reset command failed' };
      }
      
      // Step 2: Wait a moment for device to process
      if (onProgress) onProgress('Waiting for device to process...');
      await wait(3000);
      
      // Step 3: Clear logs from database (as in Vue)
      // New Installation skips this cleanup; standalone Memory Reset keeps it.
      if (clearLogs) {
        if (onProgress) onProgress('Clearing logs from database...');
      
        if (isOled) {
          await axios.get(`${API_BASE_URL}/v2/eeprom/deletewifilogs?deviceId=${devId}`);
          await axios.get(`${API_BASE_URL}/v2/ping/deletewifiresp/${devId}`);
          await axios.get(`${API_BASE_URL}/v2/ping/deletefgresp/${devId}`);
        } else {
          await axios.get(`${API_BASE_URL}/v2/eeprom/deletecbwifilogs?cbid=${devId}`);
          await axios.get(`${API_BASE_URL}/v2/ping/deletewifiresp/${devId}`);
          await axios.get(`${API_BASE_URL}/v2/ping/deletefgresp/${devId}`);
        }
      }
      
      return { success: true, message: 'Memory reset completed successfully' };
      
    } catch (error) {
      console.error('Memory reset error:', error);
      return { success: false, message: 'Memory reset failed: ' + error.message };
    }
  },
  
  // Read logs (FIXED - using wait function)
  readLogs: async (client, user, oledDevices, onProgress) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const firmwareVersion = parseFloat(client.fwversion || client.firmwareVersion || '0');
    const isOled = isOLEDDevice(client.sno, oledDevices);
    
    try {
      // Step 1: Send upload command based on firmware version
      const uploadCommand = firmwareVersion > 0.94 ? "92" : "97";
      
      if (onProgress) onProgress(`Sending command ${uploadCommand} to device...`);
      
      const cmdData = {
        devId: devId,
        command: uploadCommand,
        resp: "",
        refby: user.dealerId,
        role: user.role
      };
      
      const response = await sendCommand(cmdData.devId, cmdData.command, cmdData.resp, cmdData.refby, cmdData.role);
      
      // Check if command was accepted
      if (response.data !== "OPERATION DONE") {
        if (response.data && response.data.includes('already exists')) {
          return { success: false, message: 'Another operation is in progress. Please wait.' };
        }
        return { success: false, message: 'Failed to start log upload' };
      }
      
      if (onProgress) onProgress('Command sent, waiting for logs to upload...');
      
      // Step 2: Poll for log upload completion
      const logCheckEndpoint = isOled
        ? `${API_BASE_URL}/v2/eeprom/getwifilogs?deviceId=${devId}`
        : `${API_BASE_URL}/v2/eeprom/getcbwifilogs?cbid=${devId}`;
      
      let previousLogCount = 0;
      let stableCount = 0;
      let maxAttempts = 20;
      let uploadComplete = false;
      let finalLogs = [];
      
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        await wait(2000);
        
        try {
          const logResponse = await axios.get(logCheckEndpoint);
          const currentLogs = logResponse.data || [];
          const currentLogCount = currentLogs.length;
          
          if (currentLogCount > 0) {
            // Keep the latest received logs even when the device only uploads
            // one or two records and never reaches the stability threshold.
            finalLogs = currentLogs;
            if (currentLogCount === previousLogCount) {
              stableCount++;
              if (stableCount >= 3) {
                uploadComplete = true;
                finalLogs = currentLogs;
                break;
              }
            } else {
              stableCount = 0;
              previousLogCount = currentLogCount;
              if (onProgress) onProgress(`Uploading logs... (${currentLogCount} logs received)`);
            }
          } else if (attempt > 5) {
            if (onProgress) onProgress('Waiting for logs...');
          }
        } catch (err) {
          console.log('Polling attempt failed:', err);
          if (attempt > 10) {
            uploadComplete = true;
            break;
          }
        }
      }
      
      if (uploadComplete || finalLogs.length > 0) {
        return { 
          success: true, 
          message: `Logs uploaded successfully! Total logs: ${finalLogs.length}`,
          logs: finalLogs
        };
      } else {
        return { 
          success: true, 
          message: 'Log upload command sent. Logs may take a few minutes to appear.',
          logs: []
        };
      }
      
    } catch (error) {
      console.error('Read logs error:', error);
      return { success: false, message: 'Failed to read logs: ' + (error.response?.data || error.message) };
    }
  },

  quickReadLogs: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const firmwareVersion = parseFloat(client.fwversion || client.firmwareVersion || '0');
    
    try {
      const uploadCommand = firmwareVersion > 0.94 ? "92" : "97";
      
      const cmdData = {
        devId: devId,
        command: uploadCommand,
        resp: "",
        refby: user.dealerId,
        role: user.role
      };
      
      const response = await sendCommand(cmdData.devId, cmdData.command, cmdData.resp, cmdData.refby, cmdData.role);
      
      if (response.data === "OPERATION DONE") {
        return { success: true, message: 'Log upload command sent successfully' };
      } else if (response.data && response.data.includes('already exists')) {
        return { success: false, message: 'Another operation is in progress' };
      } else {
        return { success: false, message: 'Failed to send log upload command' };
      }
      
    } catch (error) {
      console.error('Quick read logs error:', error);
      return { success: false, message: 'Failed to send command' };
    }
  },

  // Set OTP on device (Command 104)
setOTP: async (client, user, oledDevices) => {
  const devId = getTargetDeviceId(client, oledDevices);
  const response = await sendCommand(devId, '104', '', user.dealerId, user.role);
  return handleCommandResponse(response, 'SET OTP');
},

// Get OTPs from device (shows existing OTPs)
getOTPs: async (client, oledDevices) => {
  const devId = getTargetDeviceId(client, oledDevices);
  
  try {
    const response = await axios.get(
      `${API_BASE_URL}/v2/ping/getdeviceotps?deviceId=${devId}`
    );
    
    if (response.data && Array.isArray(response.data)) {
      return { success: true, otps: response.data };
    }
    return { success: true, otps: [] };
  } catch (error) {
    console.error('Failed to get OTPs:', error);
    return { success: false, message: 'Failed to fetch OTPs', otps: [] };
  }
},
  
  // Set time
  setTime: async (client, user, oledDevices, timezone) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '86', timezone, user.dealerId, user.role);
    return handleCommandResponse(response, 'SET TIME');
  },
  
  // Device info
  deviceInfo: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '80', '', user.dealerId, user.role);
    
    if (response.data === 'OPERATION DONE') {
      let attempts = 0;
      const maxAttempts = 15;
      
      while (attempts < maxAttempts) {
        await wait(3000);
        
        try {
          const wifiresp = await axios.get(`${API_BASE_URL}/v2/ping/wifiresponse/${devId}`);
          const fgresp = await axios.get(`${API_BASE_URL}/v2/ping/fgresponse/${devId}`);
          
          const data = wifiresp.data || fgresp.data;
          
          if (data && data[0] && data[0].response) {
            const parsed = parseDeviceInfoResponse(data[0].response, client);
            return { success: true, data: parsed };
          }
        } catch (err) {
          // Continue polling
        }
        
        attempts++;
      }
      
      return { success: false, message: 'No response from device' };
    }
    
    return handleCommandResponse(response, 'DEVICE INFO');
  },
  
  // Take picture
  takePicture: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '83', '', user.dealerId, user.role);
    return handleCommandResponse(response, 'TAKE PICTURE');
  },
  
  // Bypass
  bypass: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '88', '', user.dealerId, user.role);
    return handleCommandResponse(response, 'BYPASS');
  },
  
  // Unbypass
  unbypass: async (client, user, oledDevices) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '89', '', user.dealerId, user.role);
    return handleCommandResponse(response, 'UNBYPASS');
  },
  
  // One day pass
  oneDayPass: async (client, user, oledDevices, days = 1) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const response = await sendCommand(devId, '30', days.toString(), user.dealerId, user.role);
    return handleCommandResponse(response, 'ONE DAY PASS');
  },
  
  // Device config
  deviceConfig: async (client, user, oledDevices, config) => {
    const devId = getTargetDeviceId(client, oledDevices);
    const configString = typeof config === 'string' ? config : config;
    const refby = user.role === 'office' ? user.officeId : user.dealerId;
    const response = await sendConfigCommand(devId, '94', configString, refby, user.role);
    return handleCommandResponse(response, 'DEVICE CONFIG');
  },
  
  // Get default device config
  getDefaultDeviceConfig: (state, blowStrength = 'low') => {
    const baseConfigs = {
      WI: { 
        low: '60,50,20,35,800,30,20,0', 
        medium: '60,50,20,55,1000,30,20,0', 
        high: '60,50,20,60,1100,30,20,0' 
      },
      default: { 
        low: '60,30,25,35,800,30,20,0', 
        medium: '60,30,25,55,1000,30,20,0', 
        high: '60,30,25,60,1100,30,20,0' 
      }
    };
    
    const stateConfigs = baseConfigs[state] || baseConfigs.default;
    return stateConfigs[blowStrength];
  },
  
  clearStorage: async (client, user, oledDevices, dealerEmail, dealerPassword) => {
  const devId = getTargetDeviceId(client, oledDevices);
  const isOled = isOLEDDevice(client.sno, oledDevices);
  const firmwareVersion = parseFloat(client.fwversion || client.firmwareVersion || '0');
  
  try {
    // Step 1: Verify dealer credentials
    const verifyResponse = await axios.get(
      `${API_BASE_URL}/us/calogin/getuniquelogin?emailId=${encodeURIComponent(dealerEmail)}&password=${encodeURIComponent(dealerPassword)}`
    );
    
    if (!verifyResponse.data || verifyResponse.data.length === 0) {
      return { success: false, message: 'Invalid credentials. Please check your email and password.' };
    }
    
    // Step 2: Delete EEPROM logs from database (THIS IS WHAT ACTUALLY DELETES THE LOGS)
    try {
      if (isOled) {
        // Delete WiFi logs for OLED devices
        await axios.get(`${API_BASE_URL}/v2/eeprom/deletewifilogs?deviceId=${devId}`);
        console.log('Deleted OLED logs for deviceId:', devId);
      } else {
        // Delete all control-board logs, including Wi-Fi and 4G records.
        await axios.get(`${API_BASE_URL}/v2/eeprom/deletecballLogs?cbid=${encodeURIComponent(devId)}`);
        await axios.get(`${API_BASE_URL}/v2/eeprom/deletecbwifilogs?cbid=${devId}`);
        console.log('Deleted CBID logs for cbid:', devId);
      }
    } catch (eepromError) {
      console.error('Error deleting EEPROM logs:', eepromError);
      // Try GET method if DELETE fails (API might only support GET)
      try {
        if (isOled) {
          await axios.get(`${API_BASE_URL}/v2/eeprom/deletewifilogs?deviceId=${devId}`);
        } else {
          await axios.get(`${API_BASE_URL}/v2/eeprom/deletecbwifilogs?cbid=${devId}`);
        }
      } catch (retryError) {
        console.error('Retry also failed:', retryError);
      }
    }
    
    // Step 3: Clear ping responses
    try {
      await axios.get(`${API_BASE_URL}/v2/ping/deletewifiresp/${devId}`);
      await axios.get(`${API_BASE_URL}/v2/ping/deletefgresp/${devId}`);
      await axios.get(`${API_BASE_URL}/app/commands/deletecommand/${devId}`);
      console.log('Cleared responses for device:', devId);
    } catch (clearError) {
      console.error('Error clearing responses:', clearError);
    }
    
    return { success: true, message: 'Device storage cleared successfully. All logs have been deleted from database.' };
    
  } catch (error) {
    console.error('Clear storage error:', error);
    return { success: false, message: 'Failed to clear storage: ' + (error.response?.data || error.message) };
  }
},
  
  // New installation - full flow
  newInstallation: async (client, user, oledDevices, onProgress) => {
    try {
      // Step 1: Memory Reset
      if (onProgress) onProgress('Memory reset in progress...');
      // Database log deletion is disabled for New Installation. Preserve the original call:
      // const memResult = await deviceCommands.memoryReset(client, user, oledDevices, onProgress);
      const memResult = await deviceCommands.memoryReset(client, user, oledDevices, onProgress, false);
      if (!memResult.success) {
        return { success: false, message: 'Memory reset failed. Installation aborted.' };
      }
      
      // Step 2: Device Configuration with default values "60,30,25"
      if (onProgress) onProgress('Configuring device...');
      const defaultConfig = "60,30,25";
      const configResult = await deviceCommands.deviceConfig(client, user, oledDevices, defaultConfig);
      if (!configResult.success) {
        return { success: false, message: 'Device configuration failed. Installation aborted.' };
      }
      
      // Step 3: Update device status to "Installed"
      if (onProgress) onProgress('Updating device status...');
      const statusUpdated = await updateDeviceStatus(client, oledDevices);
      if (!statusUpdated) {
        console.warn('Device status update failed, but installation may still be complete');
      }
      
      // Step 4: Create installation invoice
      // if (onProgress) onProgress('Creating invoice...');
      // const invoiceCreated = await createInstallationInvoice(client, user);
      // if (!invoiceCreated) {
      //   console.warn('Invoice creation failed, but device is installed');
      // }
      
      return { 
        success: true, 
        message: 'New installation completed successfully! Device configured.'
      };
      
    } catch (error) {
      console.error('New installation error:', error);
      return { success: false, message: 'Installation failed: ' + error.message };
    }
  }
};

// Helper to parse device info response
export function parseDeviceInfoResponse(response, client) {
  const rawResponse = typeof response === 'string' ? response : String(response ?? '');
  const data = rawResponse.split(',');

  
  const deviceMode = String(
    client?.devicemode || client?.deviceMode || client?.devicemodel || ''
  ).trim().toUpperCase();

  // A200U returns its complete configuration in command 80. Keep this mapping
  // separate from the legacy device response, whose field positions differ.
  if (deviceMode === 'A200U') {
  const a200uFields = [
  'mac_buff',                                      // 0
  'fversion',                                      // 1
  'cam1_time',                                     // 2
  'datebuf',                                       // 3
  'local_params.next_cal_date',                    // 4
  'cb_version',                                    // 5
  'eng_battery_adc',                               // 6
  'cb_mac_neo',                                    // 7
  'offset_pre',                                    // 8
  'alco_sen_offset',                               // 9
  'tmp75',                                         // 10
  'bt',                                            // 11
  'a',                                             // 12
  'Brac_peak_factor30',                            // 13
  'calibration_set_flag',                          // 14
  'proxy_en_dis',                                  // 15
  'brao_en_dis',                                   // 16
  'temp_en_dis',                                   // 17
  'fail_count_config',                             // 18
  'refused_count_config',                          // 19
  'eng_off_min_config',                            // 20
  'batter_tamp_time',                              // 21
  'insufficient_count_config',                    // 22
  'first_rr_timer_config',                         // 23
  'lc_days_config',                                // 24
  'cal_grace_config',                              // 25
  'second_rr_timer_config',                        // 26
  'initial_lock_timer_config',                     // 27
  'first_initial_lockout_timer',                   // 28
  'second_initial_lockout_timer',                  // 29
  'display_results_flag',                          // 30
  'rr_test_fail_refuse_timer',                     // 31
  'lock_days',                                     // 32
  'brac_sol_cal_value',                            // 33
  'ab_current_params.init_brac_threshold',         // 34
  'custom_vol',                                    // 35
  'custom_time_blow',                              // 36
  'ab_current_params.breath_temp_min_threshold',   // 37
  'ab_current_params.breath_temp_max_threshold',  // 38
  'random_test',                                   // 39
  'device_status_flag',                            // 40
  'device_type_flag',                              // 41
  'device_type_buff'                               // 42
];

    // ADD CONSOLE HERE

    // a200uFields.forEach((field, index) => {
    //   console.log(`${index} | ${field} | ${data[index] ?? ''}`);
    // });

    // if (data.length > a200uFields.length) {
    //   console.log(
    //     `${data.length - 1} | DEVICE_TYPE | ${data[data.length - 1]}`
    //   );
    // }

    // console.log('================================');

    // Some A200U firmware versions omit rr_test_fail_refuse_timer (one fewer
    // value returned). DEVICE_TYPE is always the final value, so keep
    // it aligned and show the omitted setting as blank.
    const missingRrTestTimer = data.length === a200uFields.length - 1 &&
      String(data[data.length - 1] || '').trim().toUpperCase() === 'A200U';
    const missingRrTestTimerIndex = a200uFields.indexOf('rr_test_fail_refuse_timer');
    const values = missingRrTestTimer
      ? [
          ...data.slice(0, missingRrTestTimerIndex),
          '',
          ...data.slice(missingRrTestTimerIndex)
        ]
      : data;

const parsed = a200uFields.reduce((result, field, index) => {
  result[field] = values[index] ?? '';
  return result;
}, {});


Object.defineProperty(parsed, '__rawParameterCount', {
  value: data.length,
  enumerable: false
});

return parsed;
  }
  
  // Legacy devices, including A200U, can return a shorter command-80 payload.
  // Map only positions that were actually returned so the UI can render a
  // concise, accurate set of cards instead of relying on a model-specific
  // static fixture or showing unavailable values.
  if (rawResponse.trim()) {
    const legacyFields = [
      'deviceId', 'firmware', 'deviceTime', 'calibrationDate',
      'nextCalibrationDate', 'cbFirmware', 'bacCutoff', 'controlBoardId',
      'offsetPressure', 'alcoADC', 'ambTemp', 'breathTemp', 'altitude',
      'bracPeakFactor', 'calFlag', 'engineOffTimer', 'randomTestStatus',
      null, 'randomTestInterval', 'blowVolume', 'blowTimeout'
    ];

    return legacyFields.reduce((parsed, field, index) => {
      if (field && index < data.length) parsed[field] = data[index] ?? '';
      return parsed;
    }, {});
  }

  return {};
}
